// import React, { useState, useEffect } from "react";
// import { getAuthor } from "../../lib/firebase/author/read_server";
// import { getCategory } from "../../lib/firebase/category/read_server";
// import { getPost } from "../../lib/firebase/post/read_server";
// import { useParams } from "react-router-dom";
// import AuthorCard from "../common/AuthorCard";
// import CategoryCard from "../common/CategoryCard";

// export default function PostPage() {
//     const { postId } = useParams();
//     const [post, setPost] = useState(null);

//     useEffect(() => {
//         async function fetchPost() {
//             const fetchedPost = await getPost(postId);
//             setPost(fetchedPost);
//         }
//         fetchPost();
//     }, [postId]);

//     if (!post) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <main className="d-flex justify-content-center">
//             <section className="d-flex flex-column gap-5 px-5 py-4 max-w-800">
//                 <CategoryCard categoryId={post?.categoryId} />
//                 <h1 className="fs-2 fw-bold">{post?.title}</h1>
//                 <img className="w-100 object-cover" src={post?.imageURL} alt="Post" />
//                 <div className="d-flex justify-content-between align-items-center">
//                     <AuthorCard authorId={post?.authorId} />
//                     <h5 className="text-muted small">{new Date(post?.timestamp?.toDate()).toLocaleDateString()}</h5>
//                 </div>
//                 <div dangerouslySetInnerHTML={{ __html: post?.content }}></div>
//             </section>
//         </main>
//     );
// }

import React, { useState, useEffect } from "react";
import { getAuthor } from "../../lib/firebase/author/read_server";
import { getCategory } from "../../lib/firebase/category/read_server";
import { getPost } from "../../lib/firebase/post/read_server";
import { useParams } from "react-router-dom";
import "../../css/components/PostPage/PostPage.css"

export default function PostPage() {
    const { postId } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        async function fetchPost() {
            const fetchedPost = await getPost(postId);
            setPost(fetchedPost);

            // Update Page Metadata (Title, OG Image)
            if (fetchedPost?.title) {
                document.title = fetchedPost.title;
            }
        }
        fetchPost();
    }, [postId]);

    if (!post) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    return (
        <main className="d-flex justify-content-center">
            <section className="d-flex flex-column gap-3 p-4 shadow-lg rounded bg-white w-75">
                <CategoryCard categoryId={post?.categoryId} />
                <h1 className="fs-2 fw-bold">{post?.title}</h1>
                <img className="img-fluid rounded" src={post?.imageURL} alt="Post" />
                <div className="d-flex justify-content-between align-items-center">
                    <AuthorCard authorId={post?.authorId} />
                    <h5 className="text-muted">
                        {post?.timestamp ? new Date(post.timestamp.toDate()).toLocaleDateString() : "No date"}
                    </h5>
                </div>
                <div dangerouslySetInnerHTML={{ __html: post?.content }} className="border rounded p-3 bg-light post-page"></div>
            </section>
        </main>
    );
}

function AuthorCard({ authorId }) {
    const [author, setAuthor] = useState(null);

    useEffect(() => {
        async function fetchAuthor() {
            const fetchedAuthor = await getAuthor(authorId);
            setAuthor(fetchedAuthor);
        }
        fetchAuthor();
    }, [authorId]);

    if (!author) return <div>Loading Author...</div>;

    return (
      <div className="d-flex align-items-center gap-2">
        <img
          className="rounded-circle border border-2 border-dark"
          src={author?.photoURL}
          alt="Author"
          width="40"
          height="40"
        />
        <h5 className="text-muted  mb-0">{author?.name}</h5>
      </div>
    );
}

function CategoryCard({ categoryId }) {
    const [category, setCategory] = useState(null);

    useEffect(() => {
        async function fetchCategory() {
            const fetchedCategory = await getCategory(categoryId);
            setCategory(fetchedCategory);
        }
        fetchCategory();
    }, [categoryId]);

    if (!category) return <div>Loading Category...</div>;

    return (
      <div className="d-flex flex-row align-items-center  bg-light border rounded-pill px-2 py-1">
        <img
          className="rounded-circle border border-1 border-dark me-2"
          src={category?.iconURL}
          alt="Category"
          width="35"
          height="35"
        />
        <h5 className="text-muted mb-0">{category?.name}</h5>
      </div>
    );
}
